var validateCardCvv = (cvv, _ref) => {
  var {
    props
  } = _ref;
  var isPresent = Boolean(cvv.length);
  var result = {
    invalidFormat: isPresent && !/^\d+$/.test(cvv),
    tooLong: Number(props.maxLength) < cvv.length,
    tooShort: isPresent && Number(props.minLength) > cvv.length,
    valueMissing: Boolean(props.required) && !isPresent
  };
  result.errors = Object.keys(result).filter(key => result[key]);
  result.isValid = result.valueMissing && !props.required || !result.errors.length;
  return result;
};

export { validateCardCvv };